import { Link, useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在 - 萝莉动漫主题站",
    description: "你访问的页面不存在或已被移除，返回首页继续浏览萝莉动漫角色资料与最新资讯。"
  });

  return (
    <div className="mx-auto flex max-w-[900px] flex-col items-center justify-center px-4 py-24 text-center">
      <div className="relative mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-primary-100 text-primary-500 animate-floaty">
        <i className="ri-emotion-sad-line text-5xl"></i>
      </div>
      <p className="font-heading text-6xl text-primary-500">404</p>
      <h1 className="mt-4 text-2xl text-foreground-950">页面走丢了</h1>
      <p className="mt-3 text-sm text-foreground-600">
        你访问的页面不存在或已被移除：
        <span className="ml-1 rounded bg-background-100 px-2 py-0.5 font-mono text-xs text-foreground-700">
          {location.pathname}
        </span>
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/roles"
          className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-user-heart-line"></i>
          浏览角色库
        </Link>
        <Link
          to="/news"
          className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-newspaper-line"></i>
          查看资讯
        </Link>
      </div>
    </div>
  );
}